import { useViewerPlugin } from '@stereograph/teiaviewer';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Alias, TiaAliasTableApi } from './TiaAliasTableApi';

export const TiaAliasTablesApiQueryKey = 'AliasTables';

const useTiaAliasTableApi = () => {
  const { plugin } = useViewerPlugin('chatbot');
  const client = plugin.elliotAPIClient;

  return TiaAliasTableApi(client);
};

export const useGetAllAliasTables = () => {
  const api = useTiaAliasTableApi();

  return useQuery({
    queryKey: [TiaAliasTablesApiQueryKey],
    queryFn: () => api.getAllAliasTables(),
  });
};

export const useCreateAliasTable = () => {
  const api = useTiaAliasTableApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (t: { aliasTable: Alias }) => {
      const result = await api.createAliasTable(t.aliasTable);
      await queryClient.invalidateQueries({
        queryKey: [TiaAliasTablesApiQueryKey],
      });

      return result;
    },
  });
};

export const useUpdateAliasTable = () => {
  const api = useTiaAliasTableApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (t: {
      aliasTable: Alias;
      id: string;
    }) => {
      const result = await api.updateAliasTable(t.aliasTable, t.id);
      await queryClient.invalidateQueries({
        queryKey: [TiaAliasTablesApiQueryKey],
      });

      return result;
    },
  });
};

export const useDeleteAliasTable = () => {
  const api = useTiaAliasTableApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (t: { id: string }) => {
      const result = await api.deleteAliasTable(t.id);
      await queryClient.invalidateQueries({
        queryKey: [TiaAliasTablesApiQueryKey],
      });

      return result;
    },
  });
};

export const useAliasInputJsonSchema = () => {
  const api = useTiaAliasTableApi();

  return useQuery({
    queryKey: [TiaAliasTablesApiQueryKey, 'AliasInputJsonSchema'],
    queryFn: () => api.getAliasInputJsonSchema(),
  });
};
